import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VContainer,
    {
      class: {
        largePage: _vm.$vuetify.breakpoint.mdAndUp,
        "px-5": _vm.$vuetify.breakpoint.smAndDown,
      },
      attrs: { fluid: "" },
    },
    [
      _c("div", { staticClass: "text-h4 my-4" }, [
        _vm._v("Verwaltung der Erhebungsperioden je Gemeinde"),
      ]),
      _vm._v(" "),
      _c(VDivider, { staticClass: "mb-4" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex align-center" },
        [
          _c(VAutocomplete, {
            staticClass: "mr-4",
            attrs: {
              items: _vm.regionalcodes,
              disabled: _vm.creatingNewPeriode,
              outlined: "",
              dense: "",
              "hide-details": "",
              "item-text": "displayname",
              "item-value": "id",
              placeholder: "Gemeinde",
            },
            on: {
              change: (value) => {
                _vm.$router.push({ query: { regionalcode: value } })
              },
            },
            model: {
              value: _vm.selectedRegionalcode,
              callback: function ($$v) {
                _vm.selectedRegionalcode = $$v
              },
              expression: "selectedRegionalcode",
            },
          }),
          _vm._v(" "),
          _c(
            VBtn,
            {
              attrs: {
                color: "primary",
                disabled: !_vm.selectedRegionalcode,
                loading: _vm.creatingNewPeriode,
              },
              on: {
                click: function ($event) {
                  return _vm.createNewPeriode()
                },
              },
            },
            [_vm._v("\n      Neue Periode\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.snapshots.length
        ? _c(VDataTable, {
            staticClass: "mt-4",
            attrs: {
              headers: _vm.headers,
              items: _vm.snapshots,
              "item-key": "timestamp",
              "disable-filtering": "",
              "disable-sort": "",
              "hide-default-footer": "",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "item.Erhebungsperiode",
                  fn: function ({ index }) {
                    return [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.getNameForIndex(index)) +
                          "\n    "
                      ),
                    ]
                  },
                },
                {
                  key: "item.beginn",
                  fn: function ({ index }) {
                    return [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.getBeginnForTimestamp(index)) +
                          "\n    "
                      ),
                    ]
                  },
                },
                {
                  key: "item.Fertigstellung",
                  fn: function ({ item, index }) {
                    return [
                      index === 0
                        ? _c("span", { staticClass: "pl-3" }, [_vm._v("-")])
                        : item.progress !== null
                        ? _c(VProgressLinear, {
                            attrs: {
                              value: item.progress || 0,
                              color: "amber",
                              height: "25",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ value }) {
                                    return [
                                      _c("strong", [
                                        _vm._v(_vm._s(Math.ceil(value)) + "%"),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        : _vm._e(),
                    ]
                  },
                },
                {
                  key: "item.actions",
                  fn: function ({ item, index }) {
                    return [
                      _c(
                        VTooltip,
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    index !== _vm.snapshots.length - 1
                                      ? _c(
                                          VBtn,
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "actionButton",
                                                attrs: { text: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.deletePeriode(
                                                      item,
                                                      index
                                                    )
                                                  },
                                                },
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(
                                              VIcon,
                                              { attrs: { color: "error" } },
                                              [_vm._v(" mdi-delete ")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c("span", [_vm._v(" Snapshot löschen ")]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        VTooltip,
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      VBtn,
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass: "actionButton",
                                            attrs: { text: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.goToGemeinde(
                                                  item,
                                                  index
                                                )
                                              },
                                            },
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c(VIcon, { staticClass: "mx-2" }, [
                                          _vm._v(" mdi-map "),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c("span", [_vm._v(" Ansicht im Erhebungsclient ")]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        VTooltip,
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    index !== _vm.snapshots.length - 1
                                      ? _c(
                                          VBtn,
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "actionButton",
                                                attrs: {
                                                  text: "",
                                                  href: _vm.getDownloadLink(
                                                    item
                                                  ),
                                                  download: "",
                                                },
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(VIcon, [
                                              _vm._v(" mdi-download "),
                                            ]),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c("span", [_vm._v(" Snapshot downloaden ")]),
                        ]
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              2445643575
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }